import { useEffect, useRef } from 'react';

interface HeadwayConfig {
  readonly selector: string;
  readonly account: string;
}

interface HeadwayAPI {
  init: (config: HeadwayConfig) => void;
}

declare global {
  interface Window {
    Headway?: HeadwayAPI;
  }
}

export const headwayConfig = {
  account: '76Aqnx',
  elementId: 'headway',
  badgeContainerId: 'HW_badge_cont',
} as const;

export const useHeadway = (): void => {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    // Prevent duplicate script loading
    if (scriptRef.current) return;

    const script = document.createElement('script');
    script.src = '//cdn.headwayapp.co/widget.js';
    script.async = true;

    script.onerror = (): void => {
      console.error(
        'Headway failed to load - notifications will not be available'
      );
    };

    script.onload = (): void => {
      window.Headway?.init({
        selector: `#${headwayConfig.elementId}`,
        account: headwayConfig.account,
      });
    };

    document.head.appendChild(script);
    scriptRef.current = script;

    return (): void => {
      if (scriptRef.current) {
        document.head.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
    };
  }, []);
};
